import { Component, EventEmitter, Input, Output, signal } from '@angular/core';

import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Subject, tap, takeUntil, finalize, catchError } from 'rxjs';
import { IResponse } from '../../../models/iresponse';
import { Products } from '../../../models/products';
import { WholesaleBills } from '../../../models/wholesale-bills';
import { DateFormatService } from '../../../services/date-format.service';
import { SnackBarService } from '../../../services/snackBar.service';
import { WholesaleService } from '../../../services/wholesale/wholesale.service';
import { OraclepridgeService } from '../../../services/oracle/oraclepridge.service';

@Component({
  selector: 'app-wholesale-bills-table',
  templateUrl: './wholesale-bills-table.component.html',
  styleUrl: './wholesale-bills-table.component.scss'
})
export class WholesaleBillsTableComponent {

  _unsubscribe$: Subject<boolean> = new Subject()

  @Input() dataSource: WholesaleBills[] = []
  @Input() isPrinting:boolean = false
  @Output() onShowDetails = new EventEmitter<any>();
  isLoadingMail = signal<number|null>(null)
  isLoadingBill = signal<number|null>(null)

  ngOnInit(): void {
  }

  constructor(
    public dateFormatService: DateFormatService,
    private wholesaleService: WholesaleService,
    private snackBarService: SnackBarService,
    private translateService: TranslateService,
    private oraclepridgeService: OraclepridgeService,
  ) { }

  confirmDialog(item: WholesaleBills) {
    Swal.fire({
      title: this.translateService.instant('SwalMessages.confirmSend'),
      icon: 'info',
      showCancelButton: true,
      cancelButtonText: this.translateService.instant('Common.Discard'),
      confirmButtonText: this.translateService.instant('Common.Confirm'),
      showLoaderOnConfirm: true,
      preConfirm: () => {
        this.sendMail(item);
      },
    })
  }

  sendMail(item: WholesaleBills){
    this.isLoadingMail.set(item.Id)
    this.wholesaleService.sendEmail(item.Id)
    .pipe(
      tap(
        (result: IResponse<Products>) => {
          if (result.Data) {
            this.snackBarService.success('ToastMessages.SuccSend')
          }
        }
      ),
      takeUntil(this._unsubscribe$),
      finalize(() => { this.isLoadingMail.set(null) })
    )
    .subscribe();
  }

  sendOracle(item: WholesaleBills){
    let body = {
      billIds: [item.Id]
    }
    this.isLoadingBill.set(item.Id)
    this.oraclepridgeService.SendData(body)
    .pipe(
      tap(
        (result) => {
          if (result.IsSuccess) {
            this.snackBarService.success('ToastMessages.SuccSend');
            item.SentStatus=1
          } else {
            this.snackBarService.error('ToastMessages.SendFailed');
          }
        }
      ),
      takeUntil(this._unsubscribe$),
      finalize(()=>this.isLoadingBill.set(null)),
      catchError((err)=>{
        this.snackBarService.error(err.message);
        throw err
      })
    )
    .subscribe()
  }

  showDetails(item:any){
    this.onShowDetails.emit(item)
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(true)
    this._unsubscribe$.complete()
  }
}
